export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  width: '100%',
};

export const triggerFieldsStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '8px',
};

export const reasonRowStyles = {
  display: 'flex',
  gap: '8px',
};
